import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiCheckCircle, FiPlay, FiBookOpen } from 'react-icons/fi';

const PaymentSuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8">
        <div className="text-center">
          <FiCheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            결제 완료!
          </h1>
          <p className="text-gray-600 mb-6">
            결제가 성공적으로 처리되었습니다. 이제 강의를 시작할 수 있습니다.
          </p>

          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span className="text-gray-600">주문 상태</span>
                <span className="font-medium text-green-600">완료</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">결제 방법</span>
                <span className="font-medium">신용카드</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">처리 시간</span>
                <span className="font-medium">{new Date().toLocaleString('ko-KR')}</span>
              </div>
            </div>
          </div>

          <div className="space-y-3">
            <button
              onClick={() => navigate('/student-dashboard')}
              className="w-full bg-primary-600 text-white py-3 px-4 rounded-lg hover:bg-primary-700 transition-colors flex items-center justify-center"
            >
              <FiPlay className="w-4 h-4 mr-2" />
              <span>학습 시작하기</span>
            </button>
            
            <button
              onClick={() => navigate('/courses')}
              className="w-full bg-gray-200 text-gray-700 py-3 px-4 rounded-lg hover:bg-gray-300 transition-colors flex items-center justify-center"
            >
              <FiBookOpen className="w-4 h-4 mr-2" />
              <span>더 많은 강의 보기</span>
            </button>
          </div>

          <div className="mt-6 text-xs text-gray-500">
            <p>결제 관련 문의사항이 있으시면</p>
            <p>고객센터로 연락해주세요.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess; 